import { render } from "./ProfileTeacherModalLessons.vue?vue&type=template&id=68af498d&scoped=true"
import script from "./ProfileTeacherModalLessons.vue?vue&type=script&lang=js"
export * from "./ProfileTeacherModalLessons.vue?vue&type=script&lang=js"

import "./ProfileTeacherModalLessons.vue?vue&type=style&index=0&id=68af498d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68af498d"]])

export default __exports__